import pointBurst from '../../assets/images/pedometer/star_burst_poinf.gif';
import snackBurst from '../../assets/images/pedometer/star_burst_snack.gif';

function PedometerClaimBurst({ burst }) {
  if (!burst) return null;
  const src = burst.kind === 'snack' ? snackBurst : pointBurst;
  return <img key={burst.id} src={`${src}#${burst.id}`} alt="" className="pdm-claim-burst__img" />;

  // const testBurst = {
  //   id: '1727640000000-snack',
  //   kind: 'snack',
  // };
  // const src = testBurst.kind === 'snack' ? snackBurst : pointBurst;
  // return <img key={testBurst.id} src={`${src}#${testBurst.id}`} alt="" className="pdm-claim-burst__img" />;
}

export default PedometerClaimBurst;
